module.exports = __webpack_public_path__ + "img/diversos.11fe2166.png";